var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"home-view"},[_c('HubHome',{attrs:{"name":'spotlight',"title":_vm.spotlightTitle,"items":_vm.spotlightItems}}),_c('HubHome',{attrs:{"name":'documents',"title":_vm.documentsTitle,"items":_vm.documentsItems}}),_c('HubHome',{attrs:{"name":'events',"title":_vm.upcomingTitle,"items":_vm.upcomingItems}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }